import React from 'react';

const Footer = () => {
	return (
		<footer>
			<p>© Nora Zheng 2019</p>
		</footer>
	);
};
export default Footer;
